<!--
    Single-select language dropdown. Structure mirrors
    `user-filter-drop-down.component.html` (aumico-components) 1:1:
    button trigger → hamFlyout → checkbox list → Apply / Cancel row.
    Single-select is enforced in the TS (clicking another row replaces
    `pendingLanguage` instead of adding to a set).
-->
<div class="myc-lang-switch-wrapper">
    <!--
        Default `size="base"` — matches the other controls-bar buttons
        (Details anzeigen, PDF exportieren). The user-filter-drop-down in
        aumico-components uses `size="lg"` because its host pages put it in
        a taller toolbar; here we follow the local context instead.
    -->
    <ham-button
        #langFilterButton
        class="lang-filter-button"
        [variant]="activeLanguage ? 'transparent' : 'white'"
        [outline]="true"
        rightIcon="assets/hamIcons/chevron-down.svg"
        (click)="openFlyout(langFilterButton)"
    >
        {{ activeLanguage ? (localeI18nKey(activeLanguage) | i18next: { defaultValue: activeLanguage }) : '' }}
    </ham-button>
</div>

<span
    class="menu-flyout"
    hamFlyout
    *ngIf="openedFlyout"
    [position]="flyoutPosition"
    (closeFlyout)="closeFlyout()"
>
    <div class="flyout-scroll-wrapper">
        <div class="flyout-lang-options-content">
            <label
                *ngFor="let entry of availableLanguages"
                class="custom-checkbox lang-option"
            >
                <input
                    type="checkbox"
                    [checked]="isChecked(entry.lang)"
                    (change)="onSelect(entry.lang)"
                />
                <span class="lang-row">
                    <span class="name">
                        {{ localeI18nKey(entry.lang) | i18next: { defaultValue: entry.lang } }}
                    </span>
                    <span class="count">{{ entry.count }}</span>
                </span>
            </label>
        </div>
    </div>
    <div class="filter-actions">
        <ham-button variant="teal" size="sm" (click)="applyFilter()">
            {{ 'aumico_pm_tasks_apply_filter' | i18next }}
        </ham-button>
        <ham-button variant="white" size="sm" (click)="cancelFilter()">
            {{ 'aumico_pdf_my_language_modal_cancel' | i18next }}
        </ham-button>
    </div>
</span>
